import { useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import { Checkbox, CircularProgress, FormControlLabel, Icon, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import LHHCApiService from "app/services/LHHCApiService";
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import TopNavBar from "app/layout/TopNavBar";
import moment from 'moment';
import SubscriptionService from "app/services/SubscriptionServices";

function Horoscope({ }) {
    const subscriptionService = SubscriptionService();

    const isMobile = useMediaQuery('(max-width:600px)');
    const { t } = useTranslation();
    const apiService = LHHCApiService();
    const [horoscopeData, setHoroscopeData] = useState([]);
    const [filteredHoroscopeData, setFilteredHoroscopeData] = useState([]);
    const [loading, setLoading] = useState(true);

    const mobileColumns = [
        {
            Header: "-", accessor: "fileType", width: "25%", sortable: false,
            Cell: ({ cell }) => (
                <MDButton
                    component={Link}
                    to={`/my-files/${cell.row.original.fileType == 2 ? "match/" : ""}view/${cell.row.original.id}`}
                    variant="gradient"
                    color="success"
                    iconOnly
                    sx={{ width: 32, height: 32, minWidth: 32, minHeight: 32, p: 0 }}
                >
                    <Icon sx={{ fontSize: '0.9rem !important' }}>open_in_new</Icon>
                </MDButton>
            )
        },
        {
            Header: "description", accessor: "description",
            Cell: ({ cell }) => <>{cell.row.original.name} <br /> {cell.row.original.description}</>
        },
    ];
    const desktopColumns = [
        {
            Header: "action", accessor: "fileType", width: "11%", sortable: false,
            Cell: ({ cell }) => (
                <MDButton
                    component={Link}
                    to={`/my-files/${cell.row.original.fileType == 2 ? "match/" : ""}view/${cell.row.original.id}`}
                    variant="gradient"
                    color="success"
                    size="small"
                    sx={{ textTransform: 'none' }}
                >
                    <Icon sx={{ mr: 0.5 }}>open_in_new</Icon> Open
                </MDButton>
            )
        },
        {
            Header: "Created", accessor: "createdOn", width: "15%",
            Cell: ({ cell }) => moment(new Date(cell.row.original.createdOn)).format('DD/MM/YY HH:mm')
        },
        { Header: "name", accessor: "name", width: "12%" },
        { Header: "description", accessor: "description" },
    ];
    const columns = isMobile ? mobileColumns : desktopColumns;

    const fetchData = async () => {
            try {
                await subscriptionService.getSubscriptions();
            } catch (err) {
                console.log(err);
            }
        };
        useEffect(() => {

            fetchData();
        }, []);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const data = await apiService.list();
                setHoroscopeData(data);
                console.log(data);
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const [showHC, setShowHC] = useState(true);
    const [showMatches, setShowMatches] = useState(true);

    useEffect(() => {
        console.log("Filtering data with showHC:", showHC, "showMatches:", showMatches);
        let filteredData;
        if ((showHC && showMatches) || (!showHC && !showMatches)) {
            // Show all records if both are true or both are false
            filteredData = horoscopeData;
        } else if (showHC) {
            // Show only fileType = 1
            console.log("Filtering for fileType = 1", horoscopeData[0].fileType);
            filteredData = horoscopeData.filter(item => item.fileType == 1);
        } else if (showMatches) {
            // Show only fileType = 2
            console.log("Filtering for fileType = 2", horoscopeData[0].fileType);
            filteredData = horoscopeData.filter(item => item.fileType == 2);
        } else {
            filteredData = [];
        }
        setFilteredHoroscopeData(filteredData);
        console.log("Filtered Data: ", filteredData.length);
    }, [showHC, showMatches, horoscopeData]);

    return (
        <DashboardLayout>
            <TopNavBar />
            <MDBox pt={1} pb={1}>
                <MDBox mb={1}>
                    <Card>
                        {/* Page title */}
                        <MDBox pt={2} px={2} pb={0}>
                            <MDTypography variant="h6" fontWeight="bold" noWrap>
                                {t("HC.MY_PREVOUS_WORK")}
                            </MDTypography>
                        </MDBox>

                        {/* Create buttons */}
                        <MDBox px={2} pt={1.5} pb={0}>
                            <Stack direction="row" spacing={1.5}>
                                <MDButton
                                    component={Link}
                                    to="/my-files/horoscope/new"
                                    variant="gradient"
                                    color="info"
                                    startIcon={<Icon>add_circle</Icon>}
                                    sx={{
                                        flex: 1, minHeight: 44,
                                        textTransform: 'none',
                                        fontSize: '0.875rem',
                                        transition: 'all 0.2s',
                                        '&:hover': { boxShadow: 6, transform: 'translateY(-2px)' },
                                    }}
                                >
                                    {t("HC.HC_NEW")}
                                </MDButton>
                                <MDButton
                                    component={Link}
                                    to="/my-files/match/new"
                                    variant="gradient"
                                    color="warning"
                                    startIcon={<Icon>add_circle</Icon>}
                                    sx={{
                                        flex: 1, minHeight: 44,
                                        textTransform: 'none',
                                        fontSize: '0.875rem',
                                        transition: 'all 0.2s',
                                        '&:hover': { boxShadow: 6, transform: 'translateY(-2px)' },
                                    }}
                                >
                                    {t("HC.HC_NEW_MATCH")}
                                </MDButton>
                            </Stack>
                        </MDBox>

                        {/* Filter checkboxes + record count */}
                        <MDBox px={2} pt={0.5} pb={0}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between">
                                <Stack direction="row" alignItems="center">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={showHC}
                                                onChange={(e) => setShowHC(e.target.checked)}
                                                size="small"
                                                sx={{
                                                    color: 'info.main',
                                                    '&.Mui-checked': { color: 'info.main' },
                                                }}
                                            />
                                        }
                                        label={
                                            <MDTypography variant="caption" fontWeight="medium">
                                                {t("HC.SHOW_HC")}
                                            </MDTypography>
                                        }
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={showMatches}
                                                onChange={(e) => setShowMatches(e.target.checked)}
                                                size="small"
                                                sx={{
                                                    color: 'warning.main',
                                                    '&.Mui-checked': { color: 'warning.main' },
                                                }}
                                            />
                                        }
                                        label={
                                            <MDTypography variant="caption" fontWeight="medium">
                                                {t("HC.SHOW_MATCH")}
                                            </MDTypography>
                                        }
                                    />
                                </Stack>
                                {!loading && (
                                    <MDTypography variant="subtitle2" color="text">
                                        {filteredHoroscopeData.length} {"records"}
                                    </MDTypography>
                                )}
                            </Stack>
                        </MDBox>

                        {/* Loading spinner */}
                        {loading && (
                            <MDBox display="flex" justifyContent="center" py={4}>
                                <CircularProgress color="info" />
                            </MDBox>
                        )}

                        {/* Empty state */}
                        {!loading && filteredHoroscopeData.length === 0 && (
                            <MDBox display="flex" justifyContent="center" alignItems="center" py={4}>
                                <Icon sx={{ color: "text.secondary", mr: 1 }}>inbox</Icon>
                                <MDTypography variant="body2" color="text">
                                    No records found.
                                </MDTypography>
                            </MDBox>
                        )}

                        {/* Data table */}
                        {!loading && filteredHoroscopeData.length > 0 && (
                            <DataTable table={{
                                columns: columns,
                                rows: filteredHoroscopeData
                            }} canSearch />
                        )}
                    </Card>
                </MDBox>
            </MDBox>
        </DashboardLayout>
    );
};

Horoscope.propTypes = {
    tableData: PropTypes.array,
    cell: PropTypes.shape({
        row: PropTypes.shape({
            original: PropTypes.shape({
                fileType: PropTypes.string.isRequired,
                id: PropTypes.string.isRequired,
                createdOn: PropTypes.string.isRequired,
                name: PropTypes.string,
                description: PropTypes.string,
            }).isRequired,
        }).isRequired,
    }),
};

export default Horoscope;
